import { render } from "./LegalPage.vue?vue&type=template&id=5f88608c&scoped=true"
import script from "./LegalPage.vue?vue&type=script&lang=js"
export * from "./LegalPage.vue?vue&type=script&lang=js"

import "./LegalPage.vue?vue&type=style&index=0&id=5f88608c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f88608c"]])

export default __exports__